import React, { useRef, useState } from 'react';
import './media.css';
import img1 from '../../assets/images/media.png';
import News from '../../components/shared/news/news';
import Footer from '../shared/footer/footer';
import Header from '../shared/header/header';
import useGetAboutData from '../../Hooks/useGetAboutData';
import useGetdata from '../../Hooks/useGetData';
import MobileMenu from '../main/SnackbarNav/MobileMenu';
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import useIsMobile from '../../Hooks/useIsMobile';
const Home = () => {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  useGetdata();
  useGetAboutData();
  const sectionRef = useRef(null);

  return (
    <div className="media-page-wrapper">
      <div >
        <div ref={sectionRef} className="media-container">
          <div className="media-home-container">
            <Header />
            <img className="main-bg-img" src={img1} width={'100%'} alt="Not Found" />
          </div>
        </div>
        <div className="drone-section-container">
        </div>
      </div> 
      <section>
      {!isMobile && <SnackbarNav />}
      {isMobile && !menuOpen && (
        <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
          ☰
        </button>
      )}
       {isMobile && menuOpen && (
        <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      )}
      </section>
      <News />
      <Footer />
    </div>
  );
};
export default Home;
